import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCoins, faBolt, faArrowLeft} from "@fortawesome/free-solid-svg-icons";
// Download any celebration animation from LottieFiles and put it here
import celebrationAnimation from "../../../../assets/lottie/lesson-complete.json";
import useCountUp from "../../../../hooks/useCountUp";
import FadeIn from "./FadeIn";
import LottieView from "./LottieView";

/** A single reward card (icon + animated number + label). */
const RewardCard = ({icon, label, value, delay, iconClassName, cardClassName}) => {
    const animatedValue = useCountUp(value, 1200, delay + 300);

    return (
        <FadeIn delay={delay}>
            <div
                className={`flex flex-col items-center gap-2 rounded-2xl border p-5 shadow-sm ${cardClassName}`}
            >
                <div
                    className={`flex h-14 w-14 items-center justify-center rounded-full text-2xl ${iconClassName}`}
                >
                    <FontAwesomeIcon icon={icon}/>
                </div>

                <span className="text-3xl font-extrabold text-gray-900">
                    {animatedValue.toLocaleString("fa-IR")}
                </span>

                <span className="text-sm font-medium text-gray-500">{label}</span>
            </div>
        </FadeIn>
    );
};

/**
 * Shown after the learner completes the last lesson screen.
 * Props:
 * - credit / xp: amounts earned in THIS completion
 * - showRewards: false when the lesson was already completed before (nothing earned)
 * - onContinue: called when the learner presses the continue button
 */
const LessonComplete = ({credit = 0, xp = 0, showRewards = true, onContinue}) => (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gradient-to-b from-amber-50 via-white to-white px-6 py-10">
        <LottieView
            animationData={celebrationAnimation}
            className="h-64 w-64 sm:h-80 sm:w-80"
        />

        <FadeIn delay={200} className="text-center">
            <h2 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">
                درس تکمیل شد!
            </h2>

            <p className="mt-3 text-lg text-gray-500">
                {showRewards
                    ? "آفرین! یک قدم دیگر به هدفت نزدیک‌تر شدی."
                    : "این درس را قبلاً تکمیل کرده بودی، پس جایزه‌ای ثبت نشد."}
            </p>
        </FadeIn>

        {/* Rewards (only for a first-time completion) */}
        {showRewards && (
            <div className="mt-10 grid w-full max-w-md grid-cols-2 gap-4">
                <RewardCard
                    icon={faCoins}
                    label="اعتبار"
                    value={credit}
                    delay={500}
                    cardClassName="border-amber-200 bg-amber-50"
                    iconClassName="bg-amber-100 text-amber-500"
                />

                <RewardCard
                    icon={faBolt}
                    label="امتیاز تجربه (XP)"
                    value={xp}
                    delay={700}
                    cardClassName="border-indigo-200 bg-indigo-50"
                    iconClassName="bg-indigo-100 text-indigo-500"
                />
            </div>
        )}

        <FadeIn delay={showRewards ? 1000 : 500} className="mt-10 w-full max-w-md">
            <button
                type="button"
                onClick={onContinue}
                className="flex w-full items-center justify-center gap-2 rounded-2xl bg-green-600 py-4 text-lg font-bold text-white shadow-lg transition hover:bg-green-500 active:scale-95"
            >
                ادامه
                <FontAwesomeIcon icon={faArrowLeft}/>
            </button>
        </FadeIn>
    </div>
);

export default LessonComplete;